import { useQuery } from '@apollo/client/react'

import { graphql } from '~publish/graphql'
import type { ResultOf } from '~publish/graphql'

export const GetAccountConnectedApps = graphql(/* GraphQL */ `
  query getConnectedAppsForAccount {
    account {
      connectedApps {
        category
        clientId
        userId
        name
        description
        website
        scopes
        createdAt
      }
    }
  }
`)

type AccountResult = ResultOf<typeof GetAccountConnectedApps>
export type ConnectedApp = NonNullable<
  NonNullable<AccountResult['account']>['connectedApps']
>[number]

type UseConnectedAppsResult = {
  connectedApps: ConnectedApp[]
  isLoading: boolean
  hasError: boolean
}

/**
 * Custom hook to query the Account connected apps
 * @returns {UseConnectedAppsResult} The connected apps for the account, with loading and error state.
 */
export const useConnectedApps = (): UseConnectedAppsResult => {
  const { data, loading, error } = useQuery(GetAccountConnectedApps)

  return {
    connectedApps: data?.account?.connectedApps ?? [],
    isLoading: loading,
    hasError: !!error,
  }
}
